import script from "./UserCreationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserCreationPage.vue?vue&type=script&setup=true&lang=ts"

import "./UserCreationPage.vue?vue&type=style&index=0&id=e7482e48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7482e48"]])

export default __exports__